import {
  UseMutationResult,
  useQueryClient,
  UseQueryResult,
} from '@tanstack/react-query';
import { useSession } from '../SessionProvider';
import {
  useTrackedMutation as useMutation,
  useTrackedQuery as useQuery,
} from '@ais-ui/performance-tracking';
import { getSettings, setSettings, Settings } from './settings';

export const useGetSettings = (): UseQueryResult<Settings> => {
  const { olSession } = useSession();

  return useQuery(
    {
      queryKey: ['getSettings'],
      queryFn: () => {
        return getSettings(olSession);
      },
    },
    'settings:get',
  );
};

export const useSaveSettings = (): UseMutationResult<
  null,
  Error,
  Settings,
  Settings | undefined
> => {
  const { olSession } = useSession();
  const queryClient = useQueryClient();

  return useMutation(
    {
      mutationFn: (settings: Settings) => {
        return setSettings(olSession, settings);
      },
      onMutate: async (newSettings: Settings) => {
        await queryClient.cancelQueries({ queryKey: ['getSettings'] });
        const previousSettings = queryClient.getQueryData<Settings>([
          'getSettings',
        ]);
        queryClient.setQueryData<Settings>(['getSettings'], newSettings);
        return previousSettings;
      },
      onError: (_err, _newSettings, previousSettings) => {
        if (previousSettings) {
          queryClient.setQueryData<Settings>(['getSettings'], previousSettings);
        }
      },
      onSettled: () => {
        queryClient.invalidateQueries({ queryKey: ['mapLegendColors'] });
        queryClient.invalidateQueries({ queryKey: ['mapLegendItems'] });
      },
    },
    'settings:save',
  );
};
